import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Onboarding_Candidates = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    from: today,
    to: today,
    exclude_moved: true,
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

 



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/onboarding-candidates",
        {
          from: filters.from,
          to: filters.to,
          exclude_moved: filters.exclude_moved,
          dept_id: filters.dept_id || 0,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data || []);
      setCurrentPage(1);

      toast.success("Candidates loaded!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to load candidates");
    } finally {
      setLoading(false);
    }
  };

  const filteredItems = records.filter((item) =>
    `${item.first_name} ${item.last_name} ${item.job_title} ${item.email} ${item.contact_no}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="section-body container-fluid mt-4">
        <ToastContainer />

        <div className="card shadow-sm mb-4">
          <div className="card-header">
            <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
              <i className="fa fa-filter" style={{ marginRight: "8px" }} />
              Onboarding Candidates Filter
            </h3>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">

                <div className="col-md-4">
                  <div className="form-group required-tooltip mb-0">
                    <label>From Date</label>
                    <DatePicker
                      selected={filters.from ? new Date(filters.from) : null}
                      onChange={(date) => {
                        const value = date ? date.toLocaleDateString("en-CA") : "";
                        setFilters((prev) => ({ ...prev, from: value }));
                      }}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select From Date"
                      className="form-control required-input"
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group required-tooltip mb-0">
                    <label>To Date</label>
                    <DatePicker
                      selected={filters.to ? new Date(filters.to) : null}
                      onChange={(date) => {
                        const value = date ? date.toLocaleDateString("en-CA") : "";
                        setFilters((prev) => ({ ...prev, to: value }));
                      }}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select To Date"
                      className="form-control required-input"
                      minDate={filters.from ? new Date(filters.from) : null}
                    />
                  </div>
                </div>

                <div className="col-md-auto">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Get"}
                  </button>
                </div>

              </div>
            </form>
          </div>
        </div>

        {/* TABLE */}
        <div className="card">
          <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
            <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
              <i className="fa fa-users" style={{ marginRight: "8px" }} />
              Onboarding Candidates
            </h3>

            {/* rows-per-page sits beside the search box, same as the other screens */}
            <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
              <EntriesSelector
                entriesPerPage={entriesPerPage}
                setEntriesPerPage={setEntriesPerPage}
                setCurrentPage={setCurrentPage}
              />

              <div style={{ position: "relative", width: "100%", maxWidth: "250px", minWidth: "140px", marginLeft: "15px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <span
                    onClick={() => setSearchTerm("")}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#999"
                    }}
                  >
                    ✖
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="card-body">

            <div className="d-flex mb-2">
              <DownloadButtons data={filteredItems} filename="Onboarding_Candidates" />
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>CANDIDATE NAME</th>
                      <th>EMAIL</th>
                      <th>PHONE</th>
                      <th>JOB TITLE</th>
                      <th>RECRUIT ON</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.first_name} {row.last_name}</td>
                          <td>{row.email}</td>
                          <td>{row.contact_no}</td>
                          <td>{row.job_title}</td>
                          <td>{row.recruit_on}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-danger">
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />

          </div>
        </div>
      </div>
    </>
  );
};

export default Onboarding_Candidates;
